function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m511.271 492.349-61-180-48.308 125.14 19.085 74.606h76c4.819 0 9.346-2.314 12.173-6.226 2.812-3.911 3.588-8.95 2.05-13.52z",
  fill: "#172c4d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m.824 492.349c-1.538 4.57-.762 9.609 2.051 13.521 2.827 3.911 7.354 6.226 12.173 6.226h76l23.045-47.539-52.269-152.208z",
  fill: "#214070"
}), /*#__PURE__*/React.createElement("path", {
  d: "m439.68 302.549-11.001-2.75-162.26 125.416c-2.9 2.769-6.636 4.16-10.371 4.16-3.706 0-7.427-1.377-10.313-4.116l-163.667-125.123-9.653 2.413c-4.98 1.23-8.979 4.937-10.591 9.8l29.224 199.746h165 165l29.224-199.746c-1.612-4.863-5.611-8.57-10.592-9.8z",
  fill: "#455da0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m450.271 312.349c-1.611-4.863-5.61-8.569-10.591-9.8l-11.001-2.75-162.26 125.416c-2.9 2.769-6.636 4.16-10.371 4.16v82.72h165z",
  fill: "#214070"
}), /*#__PURE__*/React.createElement("path", {
  d: "m345.379 278.974-89.332 48.726-89.332-48.726-84.648 21.161 163.667 155.123c2.886 2.739 6.606 4.116 10.313 4.116 3.735 0 7.471-1.392 10.371-4.16l162.261-155.416z",
  fill: "#edf5ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m428.679 299.799-83.3-20.825-89.332 48.726v131.675c3.735 0 7.471-1.392 10.371-4.16z",
  fill: "#d5e8fe"
}), /*#__PURE__*/React.createElement("path", {
  d: "m319.68 272.549h-63.633-63.633l-25.699 6.425 78.726 78.726c2.93 2.93 6.768 4.395 10.605 4.395s7.676-1.465 10.605-4.395l78.726-78.726z",
  fill: "#ffccb3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m345.379 278.974-25.699-6.425h-63.633v89.546c3.838 0 7.676-1.465 10.605-4.395z",
  fill: "#fa9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m256.047 134.628h-105v61.467c0 57.891 47.109 106 105 106s105-48.109 105-106v-61.467z",
  fill: "#ffe6cc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m361.047 196.095v-61.467h-105v167.467c57.891 0 105-48.109 105-106z",
  fill: "#ffccb3"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m406.047 211.095c-8.291 0-15-6.709-15-15v-145.005c0-8.291 6.709-15 15-15s15 6.709 15 15v145.005c0 8.291-6.709 15-15 15z",
  fill: "#fabe2c"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m256.047 61.095h-105v73.533l102.539 17.097c.831.135 1.648.3 2.461.3.813.002 1.624-.163 2.461-.3l102.539-17.097v-73.533z",
  fill: "#214070"
}), /*#__PURE__*/React.createElement("path", {
  d: "m361.047 134.628v-73.533h-105v90.93c.813.002 1.624-.163 2.461-.3z",
  fill: "#172c4d"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m438.508 31.3-180-31c-.806-.132-1.633-.3-2.461-.3s-1.655.168-2.461.3l-180 31c-7.236 1.201-12.539 7.456-12.539 14.795s5.303 13.594 12.54 14.795l180 30c.837.137 1.646.302 2.461.3.813 0 1.631-.164 2.461-.3l180-30c7.236-1.201 12.539-7.456 12.539-14.795s-5.303-13.594-12.54-14.795z",
  fill: "#455da0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m438.508 60.89c7.236-1.201 12.539-7.456 12.539-14.795s-5.303-13.594-12.539-14.795l-180-31c-.806-.132-1.633-.3-2.461-.3v91.19c.813 0 1.631-.164 2.461-.3z",
  fill: "#214070"
})));

var SvgStudent = function SvgStudent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.095 512.095",
    height: 512,
    viewBox: "0 0 512.095 512.095",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStudent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/student.0b694d26.svg";
export { ForwardRef as ReactComponent };